import React from 'react'
import { isArray } from 'lodash'
import { colors } from '@lmc/common/constants'
import RadioGroup from './RadioGroup'
import { ImportantContact } from '@lmc/ts-common'

const renderLabel = (contact: any) => (
  <>
    {contact.name.first} {contact.name.last}
    <span>
      {contact.lpa &&
        isArray(contact.lpaTypes) &&
        contact.lpaTypes.map((type: any) => (
          <span key={type} style={styles.badge}>
            LPA {type}
          </span>
        ))}
    </span>
  </>
)

type PropTypes = {
  name: string
  importantContacts: Array<ImportantContact>
  onComplete: (newState: {
    lpaValue: number
    name: string
    relationship: string
  }) => void
  value: number
}

export const LpaForm = ({
  name,
  onComplete,
  value,
  importantContacts,
}: PropTypes) => {
  const onChange = (val: any) => {
    const contact = importantContacts[val]
    if (contact) {
      onComplete({
        lpaValue: val,
        name: `${contact?.name?.first} ${contact?.name?.last}`,
        // @ts-ignore
        relationship: contact.relationship,
      })
    } else {
      onComplete({
        lpaValue: val,
        name: '',
        relationship: '',
      })
    }
  }

  return (
    <div className="signature-modal-vertial-center">
      <p style={{ fontWeight: 700, fontSize: 16 }}>
        Who will sign on behalf of {name}?
      </p>
      <RadioGroup
        onChange={onChange}
        value={value}
        options={[
          ...importantContacts.map((contact, i) => ({
            // key: `${contact.name.first}${contact.name.last}`,
            value: i,
            renderLabel: () => renderLabel(contact),
          })),
          {
            label: 'Other',
            value: 'other',
          },
        ]}
      />
    </div>
  )
}

const styles = {
  badge: {
    alignSelf: 'center',
    display: 'inline-block',
    fontWeight: 'bold',
    // float: 'right',
    fontSize: 12,
    padding: '3px 12px',
    background: colors.darkgrey,
    color: 'white',
    marginLeft: 4,
    borderRadius: 15,
  },
}

export default LpaForm
